/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "English Subtitles" |
*
* @param {Image_Export_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_description_placeholder = /** @type {((inputs?: Image_Export_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Description_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres anglais")
	if (locale === "de") return /** @type {LocalizedString} */ ("Englische Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli in inglese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Английские субтитлы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulos en inglés")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("英文字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("英語字幕")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंग्रेजी में उपशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas em inglês")
	return /** @type {LocalizedString} */ ("English Subtitles")
});